<template>
  <div class="chart-box container">
    <el-row :gutter="20">
      <el-col :span="6" class="results-left">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{detailsData.irUser.userName}}</span>
            <el-button
              style="float: right;"
              size="mini"
              icon="el-icon-plus"
              @click="addAttention"
            >关注</el-button>
          </div>
          <el-image style="width: 100px;" :src="photo" fit="contain" class="personal-pic"></el-image>
          <div class="personal-info">
            <p>
              <b>科室：</b>
              {{detailsData.irUser.deptName}}
            </p>
            <p>
              <b>研究领域：</b>
              {{detailsData.irUser.fieldName}}
            </p>
            <p
              style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 4;-webkit-box-orient: vertical;"
            >
              <b>学者简介：</b>
              {{detailsData.irUser.summary}}
            </p>
          </div>
        </el-card>
        <el-card class="box-card per-card" style="margin-top: 20px">
          <div slot="header" class="clearfix">
            <span>个人成果</span>
            <el-button style="float: right;" size="mini" icon="el-icon-plus">成果提交</el-button>
          </div>
          <el-row class="guo">
            <el-col :span="12">
              <p class="guo-text">总成果</p>
              <p class="guo-num">{{detailsData.dissNum}}</p>
            </el-col>
            <el-col :span="12">
              <p class="guo-text">全文量</p>
              <p class="guo-num">{{detailsData.fullNum}}</p>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card" style="margin-top: 20px">
          <div slot="header" class="clearfix">
            <span>年度发文趋势</span>
          </div>
          <div id="yearChart" ref="yearChart" :style="{width: '100%', height: '230px'}"></div>
        </el-card>
        <el-card class="box-card" style="margin-top: 20px">
          <div slot="header" class="clearfix">
            <span>合作关系网</span>
          </div>
          <div id="relationChart" ref="relationChart" :style="{width: '100%', height: '300px'}"></div>
        </el-card>
        <el-card class="box-card" style="margin-top: 20px">
          <div slot="header" class="clearfix">
            <span>期刊发文统计</span>
          </div>
          <div id="countChart" ref="countChart" :style="{width: '100%', height: '400px'}"></div>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="公开成果" name="first">
            <el-card class="box-card" shadow="never">
              <el-row class="type-item">
                <el-col class="type-left" :span="2">类型：</el-col>
                <el-col :span="22">
                  <el-tag
                    v-for="(item,index) in typeList"
                    size="small"
                    :type="typeIndex===index?'success':'info'"
                    :key="index"
                    @click="changeType(item.baseType,index)"
                  >{{item.typeName}}（{{item.typeNum}}）</el-tag>
                </el-col>
              </el-row>
              <el-row class="type-item">
                <el-col class="type-left" :span="2">选择：</el-col>
                <el-col :span="22">
                  <el-tag
                    v-for="(item,index) in fullList"
                    size="small"
                    :type="fullIndex===index?'success':'info'"
                    :key="index"
                    @click="changeFull(item.val,index)"
                  >{{item.text}}</el-tag>
                </el-col>
              </el-row>
              <el-row class="type-item">
                <el-col class="type-left" :span="2">年度：</el-col>
                <el-col :span="22">
                  <el-tag
                    v-for="(item,index) in yearList"
                    size="small"
                    :type="yearIndex===index?'success':'info'"
                    :key="index"
                    @click="changeYear(item.year,index)"
                  >{{item.year}}（{{item.yearNum}}）</el-tag>
                </el-col>
              </el-row>
            </el-card>
            <el-row class="type-opr">
              <el-col :span="12">
                <el-button
                  type="primary"
                  size="medium"
                  plain
                  icon="el-icon-download"
                  @click="excelDown"
                >导出excel</el-button>
              </el-col>
              <el-col :span="12" style="text-align: right">
                <span>排序方式：</span>
                <el-button-group>
                  <el-button
                    :type="searchForm.sortType==='XZL'?'success':'primary'"
                    @click="changeSort('XZL')"
                    size="medium"
                    plain
                  >
                    下载量
                    <i class="el-icon-bottom el-icon--right"></i>
                  </el-button>
                  <el-button
                    :type="searchForm.sortType==='LLS'?'success':'primary'"
                    @click="changeSort('LLS')"
                    size="medium"
                    plain
                  >
                    浏览数
                    <i class="el-icon-bottom el-icon--right"></i>
                  </el-button>
                </el-button-group>
              </el-col>
            </el-row>
            <el-card class="box-card result-card" shadow="never">
              <div slot="header" class="clearfix">
                <span>
                  筛选结果
                  <b>{{total}}条</b>
                </span>
              </div>
              <el-checkbox-group v-model="checkList">
                <div v-for="item in dataList" :key="item.id" class="text item">
                  <p>
                    <el-checkbox :label="item.id" class="list-check"></el-checkbox>
                    <el-tag type="primary" size="mini" plain>{{item.includeInfo}}</el-tag>
                  </p>
                  <p>
                    <b>
                      <router-link
                        class="recommend"
                        :to="{path:'details',query:{baseId:item.id,baseType:item.baseType}}"
                      >{{item.title}}</router-link>
                    </b>
                  </p>
                  <p>
                    <b>作者：</b>
                    {{item.author}}
                  </p>
                  <!-- <p><b>刊名：</b>Chinese journal of traumatology = Zhonghua chuang shang za zhi</p>
                  <p><b>年卷期页：</b>220-8</p>-->
                  <p>
                    <b>摘要：</b>
                    {{item.summary}}
                  </p>
                </div>
              </el-checkbox-group>
            </el-card>
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :current-page="currentPage"
              :page-size="pageSizes"
              @current-change="currentChange"
              style="text-align: right"
            ></el-pagination>
          </el-tab-pane>
          <el-tab-pane label="获奖情况" name="second">
            <!-- <el-card class="box-card" shadow="never">
              <el-row class="type-item">
                <el-col class="type-left" :span="2">等级：</el-col>
                <el-col :span="22">
                  <el-tag
                    v-for="(item,index) in levelNumList"
                    size="small"
                    :type="levelIndex===index?'success':'info'"
                    :key="index"
                    @click="changeType(item.awardLevelId,index)"
                  >{{item.awardLevelName}}（{{item.awardNum}}）</el-tag>
                </el-col>
              </el-row>
              <el-row class="type-item">
                <el-col class="type-left" :span="2">年度：</el-col>
                <el-col :span="22">
                  <el-tag
                    v-for="(item,index) in yearNumList"
                    size="small"
                    :type="yearNumIndex===index?'success':'info'"
                    :key="index"
                    @click="changeYear(item.year,index)"
                  >{{item.year}}（{{item.awardNum}}）</el-tag>
                </el-col>
              </el-row>
            </el-card>
            <el-card class="box-card result-card" shadow="never">
              <div slot="header" class="clearfix">
                <span>
                  筛选结果
                  <b>{{total1}}条</b>
                </span>
              </div>
              <el-checkbox-group v-model="checkList1">
                <div v-for="item in dataList1" :key="item.id" class="text item">
                  <p>
                    <el-checkbox :label="item.id" class="list-check"></el-checkbox>
                    <el-tag type="primary" size="mini" plain>{{item.includeInfo}}</el-tag>
                  </p>
                  <p>
                    <b>
                      <router-link
                        class="recommend"
                        :to="{path:'details',query:{baseId:item.id,baseType:item.baseType}}"
                      >{{item.title}}</router-link>
                    </b>
                  </p>
                  <p>
                    <b>作者：</b>
                    {{item.author}}
                  </p>
                  <p><b>刊名：</b>Chinese journal of traumatology = Zhonghua chuang shang za zhi</p>
                  <p><b>年卷期页：</b>220-8</p>
                  <p>
                    <b>摘要：</b>
                    {{item.summary}}
                  </p>
                </div>
              </el-checkbox-group>
            </el-card>-->
            <!-- <el-pagination
              background
              layout="prev, pager, next"
              :total="total1"
              :current-page="currentPage1"
              :page-size="pageSizes"
              @current-change="currentChange1"
              style="text-align: right"
            ></el-pagination>-->
            <div style="text-align:center">
              <img src="../assets/images/2.jpg" alt />
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import List from '../components/list'
import Tags from '../components/tags'
import Operation from '../components/operation'
import Pages from '../components/pages.vue'
import YearChart from '../components/year-chart.vue'
import CountChart from '../components/count-chart.vue'
export default {
  name: 'index',
  components: {
    List,
    Tags,
    Operation,
    Pages,
    YearChart,
    CountChart,
  },
  data() {
    return {
      //url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      activeName: 'first',
      checked: false,
      userId: '',
      atUserId: '',
      total: 0,
      total1: 0,
      currentPage: 1,
      currentPage1: 1,
      pageSizes: 5,
      fullIndex: 0,
      typeIndex: 0,
      yearIndex: 0,
      levelIndex: 0,
      yearNumIndex: 0,
      photo: '',
      searchForm: {
        typeVal: '0',
        fullVal: '-1',
        sortType: 'XZL',
        yearVal: '-1',
        pageNo: 1,
      },
      searchForm1: {
        levelVal: 0,
        yearVal: 0,
        pageNo: 1,
      },
      typeList: [],
      typeList1: [],
      fullList: [
        { val: '-1', text: '所有' },
        { val: '1', text: '包含全文' },
        { val: '0', text: '不包含全文' },
      ],
      includeInfos: [],
      yearList: [],
      dataList: [],
      dataList1: [],
      checkList: [],
      checkList1: [],
      yearNumList: [],
      levelNumList: [],
      detailsData: {
        irUser: {},
        dissNum: 0,
        fullNum: 0,
        columnYearNum: [],
        columnYear: [],
        rtnVal: {},
        journalCountList: [],
      },
    }
  },
  methods: {
    currentChange(val) {
      this.searchForm.pageNo = val
      this.searchData()
    },
    currentChange1(val) {
      this.searchForm1.pageNo = val
      this.searchData()
    },
    addAttention() {
      axios({
        method: 'post',
        url:
          '/api/scholar/addAttention?userId=' +
          Number(this.$cookies.get('rtnVal')) +
          '&atUserId=' +
          Number(this.detailsData.userId),
      })
        .then(function (response) {
          alert(response.data.msg)
        })
        .catch(function (thrown) {})
    },
    yearChart() {
      let xdata = this.detailsData.columnYear
      let ydata = this.detailsData.columnYearNum
      let option = {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: ['年度发文趋势'],
        },
        grid: {
          left: '0%',
          right: '0%',
          top: '10%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: xdata,
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: '年度发文趋势',
            type: 'bar',
            data: ydata,
            barWidth: 30,
            itemStyle: {
              normal: {
                color: function (params) {
                  // build a color map as your need.
                  var colorList = [
                    '#C1232B',
                    '#B5C334',
                    '#FCCE10',
                    '#E87C25',
                    '#27727B',
                    '#FE8463',
                    '#9BCA63',
                    '#FAD860',
                    '#F3A43B',
                    '#60C0DD',
                    '#D7504B',
                    '#C6E579',
                    '#F4E001',
                    '#F0805A',
                    '#26C0C0',
                  ]
                  return colorList[params.dataIndex]
                },
              },
            },
          },
        ],
      }
      let yearChart = this.$echarts.init(document.getElementById('yearChart'))
      yearChart.setOption(option)
    },
    relationChart() {
      let json = this.detailsData.rtnVal
      let arr = [
        {x: 67111643,y: -1294321358}, // 林烈文
        {x: -2133603468,y: 1249103656}, // "代成甫"
        {x: -257880351,y: 1774363329}, // "王港"
        {x: -2076612983,y: -1199019373}, //"刘健波"
        {x: -2085869200,y: 673173323}, // "徐六妹"
        {x: 65549688,y: 822000914}, // "尹一兵"
        {x: -1417187470,y: 1816354796}, // "陈慧"
        {x: 67111643,y: -694321358}, // "欧阳昕"
        {x: 65869758,y: -1663097354}, // "文锦丽"
        {x: -456346219,y: -2023558467}, // "许小庄"
        ]
      for(let i in json.echartsDataList){
        if(json.echartsDataList[i].x == 0 && json.echartsDataList[i].y == 0){
          json.echartsDataList[i].symbolSize = 50
          json.echartsDataList[i].x = -1000000000
          json.echartsDataList[i].fixed = true
        }else{
          json.echartsDataList[i].x = arr[i].x
          json.echartsDataList[i].y = arr[i].y
          json.echartsDataList[i].fixed = true
        }
      }
      let option = {
        title: {
          text: 'NPM Dependencies',
        },
        animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            layout: 'none',
            // progressiveThreshold: 700,
            data: json.echartsDataList,
            edges: json.linksDataList,
            label: {
              normal: {
                position: 'right',
                show: true,
                color: 'black',
                fontSize: 14,
                fontStyle: 'bold',
                textBorderColor: 'transparent',
                textBorderWidth: 1,
                textShadowColor: 'transparent',
                textShadowBlur: 1,
                textShadowOffsetX: 1,
              },
            },
            roam: true,
            focusNodeAdjacency: true,
            lineStyle: {
              normal: {
                width: 0.5,
                curveness: 0.3,
                opacity: 0.7,
              },
            },
            emphasis: {
                lineStyle: {
                    width: 10
                }
            }
          },
        ],
      }
      let relationChart = this.$echarts.init(
        document.getElementById('relationChart')
      )
      relationChart.setOption(option)
      relationChart.on("click", function (params){
        console.log(params);
      });
    },
    countChart() {
      let option = {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)',
        },
        legend: {
          x: 'left',
          //                        left: 10
          orient: 'vertical',
        },
        series: [
          {
            type: 'pie',
            radius: ['38%', '83%'],
            center: ['50%', '66%'],

            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center',
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '15',
                  fontWeight: 'bold',
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: this.detailsData.journalCountList,
          },
        ],
      }
      let countChart = this.$echarts.init(document.getElementById('countChart'))
      countChart.setOption(option)
    },
    getAllAch(data) {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/user/achievement/' + data.id,
      })
        .then(function (response) {
          let typeArr = [
            {
              baseType: '0',
              typeNum: response.data.data.allTypeNum,
              typeName: '所有',
            },
          ]
          let yearArr = [{ year: '所有', yearNum: response.data.data.yearAll }]
          currThis.typeList = typeArr.concat(response.data.data.allTypeList)
          currThis.yearList = yearArr.concat(response.data.data.yearList)
        })
        .catch(function (thrown) {})
    },
    searchData(data) {
      let currThis = this
      let obj = this.searchForm
      if (data != undefined) {
        obj.userId = data.id
      }
      axios({
        method: 'get',
        url:
          '/api/index/queryScholarOneData?typeVal=' +
          obj.typeVal +
          '&fullVal=' +
          obj.fullVal +
          '&yearVal=' +
          obj.yearVal +
          '&sort=' +
          obj.sortType +
          '&userId=' +
          obj.userId +
          '&pageNo=' +
          obj.pageNo,
      })
        .then(function (response) {
          currThis.currentPage = obj.pageNo
          currThis.total = response.data.total
          currThis.pageSizes = response.data.searchSize
          currThis.dataList = response.data.list
        })
        .catch(function (thrown) {})
    },
    changeSort(val) {
      this.searchForm.sortType = val
      this.searchData()
    },
    excelDown() {
      let data = ''
      for (var i = 0; i < this.checkList.length; i++) {
        if (i === 0) {
          data += 'a' + this.checkList[i] + 'a'
        } else {
          data += this.checkList[i] + 'a'
        }
      }
      axios({
        method: 'get',
        url: '/api/index/exportExcel/1',
      })
        .then(function (response) {
          if (response.status === 200) {
            alert('导出成功')
          } else {
          }
        })
        .catch(function (thrown) {})
    },
    getJiang(data) {
      let currThis = this
      axios({
        method: 'post',
        url: '/api/user/awards/' + data.id,
      })
        .then(function (response) {
          currThis.levelNumList = response.data.data.levelNumList
          currThis.yearNumList = response.data.data.yearNumList
        })
        .catch(function (thrown) {})
    },
    searchJiang(data) {
      let currThis = this
      let obj = this.searchForm1
      obj.userId = data.id
      let url = '/api/index/queryScholarRewardData'
      axios({
        method: 'get',
        url: url,
        params: obj,
      })
        .then(function (response) {
          currThis.currentPage1 = response.data.current
          currThis.total1 = response.data.total
          currThis.pageSizes = response.data.size
          currThis.dataList1 = response.data.records
        })
        .catch(function (thrown) {})
    },
    changeType(val, index) {
      this.searchForm.typeVal = val
      this.typeIndex = index
      this.searchData()
    },
    changeFull(val, index) {
      this.searchForm.fullVal = val
      this.fullIndex = index
      this.searchData()
    },
    changeYear(val, index) {
      this.searchForm.yearVal = val
      this.yearIndex = index
      this.searchData()
    },
    changelevelNum(val, index) {
      this.searchForm.includeInfo = val
      this.levelIndex = index
      this.searchData()
    },
    changeyearNum(val, index) {
      this.searchForm.includeInfo = val
      this.yearNumIndex = index
      this.searchData()
    },
    getDetails(data) {
      let currThis = this
      axios({
        method: 'get',
        url: '/api/scholarOne/' + data.id,
      })
        .then(function (response) {
          response.data.data.columnYearNum = eval(
            '(' + response.data.data.columnYearNum + ')'
          )
          response.data.data.columnYear = eval(
            '(' + response.data.data.columnYear + ')'
          )
          response.data.data.rtnVal = eval(
            '(' + response.data.data.rtnVal + ')'
          )
          currThis.detailsData = response.data.data
          currThis.yearChart()
          currThis.relationChart()
          currThis.countChart()
          currThis.photo = '../../static' +currThis.detailsData.irUser.logUrl
        })
        .catch(function (thrown) {})
    },
  },
  mounted() {
    this.getAllAch(this.$route.query)
    this.searchData(this.$route.query)
    this.getJiang(this.$route.query)
    this.searchJiang(this.$route.query)
    this.getDetails(this.$route.query)
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/personal.vue